// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__aSEwg","Main":"Layout_Main__oWy2P"};